import { Pipe, PipeTransform, inject } from '@angular/core';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';
import { StoryblokLink } from './storyblok-types';

@Pipe({
  name: 'storyblokLinkUrl',
  standalone: true,
})
export class StoryblokLinkUrlPipe implements PipeTransform {
  private storyblokService = inject(PICFLOW_STORYBLOK);
  transform(value: StoryblokLink): string {
    return this.storyblokService.getUrlLink(value);
  }
}
